import {Button, Checkbox} from '@sportcast/ui-react';
import {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {acceptDataPrivacy} from '../../fetch/accountApi';
import {loggedIn} from '../../redux/slice/loginSlice';
import {RootState, useAppDispatch} from '../../store';
import {UserType} from '../../types/UserType';
import {formatDate} from '../../util/DateUtil';
import DataPrivacyHeader from '../common/legal-infos/DataPrivacyHeader';
import DataPrivacyText from '../common/legal-infos/DataPrivacyText';
import './DataPrivacyAcceptanceModal.scss';

interface DataPrivacyAcceptanceModalProps {
    show: boolean;
    onClose: () => void;
}

const DataPrivacyAcceptanceModal = (props: DataPrivacyAcceptanceModalProps) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const userData = useSelector((state: RootState) => state.login.userData);
    const [hasAccepted, setHasAccepted] = useState(!!userData?.dataPrivacyAcceptanceDate);
    const userIsRePortUser = useSelector((state: RootState) => !!state.login.userData?.id);

    const handleClick = () => {
        acceptDataPrivacy(dispatch).then(response => {
            if (!!response && !!response.result) {
                dispatch(loggedIn({...userData, dataPrivacyAcceptanceDate: formatDate(new Date(Date.now()))} as UserType));
                props.onClose();
            }
        });
    };

    return (
        <Modal show={props.show} className="data-privacy-modal" onHide={props.onClose}>
            <Modal.Header closeButton={!userIsRePortUser}>
                <DataPrivacyHeader/>
            </Modal.Header>
            <Modal.Body>
                <DataPrivacyText/>
            </Modal.Body>
            {
                userIsRePortUser &&
                <Modal.Footer className="data-privacy-footer">
                    <Checkbox
                        id="accept-data-privacy"
                        label={t('DataPrivacy.I_ACCEPT_DATA_PRIVACY')}
                        value={hasAccepted}
                        onChange={setHasAccepted}/>
                    <Button
                        id="close-data-privacy-modal"
                        className="float-end"
                        label={t('button.CLOSE')}
                        disabled={!hasAccepted}
                        onClick={handleClick}/>
                </Modal.Footer>
            }
        </Modal>
    );
};

export default DataPrivacyAcceptanceModal;
